import { SellHomeSection } from 'src/features/homeowners/components/sell-home-section/sell-home-section';

export const SellHomeSectionSlice = () => (
  <div className="container">
    <SellHomeSection />
  </div>
);
